// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"vu_a bhc_b"};